import type { Participant } from '@seen/core/models/patients/participant'
import type { ReactNode } from 'react'
import { ResourceFieldForm } from '#src/components/core/form/ResourceFieldForm.tsx'
import { IconLabel } from '#src/components/icons/IconLabel.tsx'
import { ParticipantLabelCombobox } from '#src/components/ParticipantLabelCombobox.tsx'
import { RowBadge } from '#src/components/TaskRowBadge.tsx'
import { ParticipantLabelCircles } from '#src/pages/participants/participant-badges/ParticipantLabelCircles.tsx'

export function ParticipantLabelsBadge({
  participant,
}: {
  participant: Participant
}): ReactNode {
  return (
    <div onClick={(e) => e.preventDefault()}>
      <ResourceFieldForm
        instance={participant}
        valueFn={(p) => p.labels}
        patchFn={(p, value) => {
          p.labels = value
        }}
        render={({ field: { value, onChange, ...rest } }) => (
          <ParticipantLabelCombobox value={value} onChange={onChange}>
            <RowBadge
              icon={
                value.length > 0 ? (
                  <ParticipantLabelCircles labelReferenceStrings={value} />
                ) : (
                  <IconLabel className="size-2.5 shrink-0" />
                )
              }
              {...rest}
            >
              {value.length === 0 && 'Add label'}
              {value.length === 1 && '1 label'}
              {value.length > 1 && `${value.length} labels`}
            </RowBadge>
          </ParticipantLabelCombobox>
        )}
      />
    </div>
  )
}
